<template>
  <div class="content">
    <div class="search-box justify-align" ref="getheight">
      <img @click="onClickLeft" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="" />
      <div class="search-box-sec left-justifying">
        <img :src="require('../../assets/'+appTheme+'/search_icon.png')" alt="" />
        <div class="searchInput" type="text" @click="onSearch">搜一搜 </div>
      </div>
    </div>
    <div class="content-cate">
      <van-tree-select :height="wh" :items="items" :main-active-index.sync="active" @click-nav="clickNav">
        <template #content>
          <div class="classify-box">
            <div class="banner-list-box" v-if="bannerList.length >= 1">
              <van-swipe class="my-swipe" :autoplay="9000" indicator-color="white">
                <van-swipe-item v-for="(item,k) in bannerList" :key="k" @click="clickDes(item.href)">
                  <img class="cover-img" :src="item.image" />
                </van-swipe-item>
              </van-swipe>
            </div>

            <!--            <img class="cover-img" v-if="currImg != ''" :src="currImg" />-->
            <div class="shop-box">
              <div class="shop-list">
                <van-list
                  v-model="loading"
                  :finished="finished"
                  :immediate-check="false"
                  :finished-text="finishedTxt"
                  @load="onLoadMore"
                >
                  <div class="shop-item left-justifying" v-for="(good,index) in giftGoods" :key="index">
                    <img class="shop-img" @click="goDesGood(good.id)" :src="good.image" alt="" />
                    <div class="content-item">
                      <div class="title" @click="goDesGood(good.id)"> {{good.name}}</div>
                      <div class="item-bottom justify-align">
                        <div class="price" @click="goDesGood(good.id)">￥{{good.price}}</div>
                        <div class="rt-box left-justifying">
                          <img @click="shareClick(good)" src="../../assets/share_icon2.png" alt="" />
                          <div class="btn" @click="goDesGood(good.id)">马上抢</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </van-list>

              </div>
            </div>
          </div>
        </template>
      </van-tree-select>
    </div>
    <!--    分享弹框-->
    <!--    分享弹框-->
    <van-overlay :show="shareShow">
      <div class="wrapper" @click.stop>
        <div class="icon-box" @click="shareShowHide"><van-icon size="24" color="#fff" name="cross" /></div>
        <img v-if="posterUrl" class="poster-url" crossorigin="anonymous" :src="posterUrl" alt="" />
        <div class="imageWrapper" v-else id="imageWrapper" ref="imageTofile">
          <img class="img-goods goodsImg" :src="shareItem.image" alt="" />
          <div class="title">{{shareItem.name}}</div>
          <img ref="qrcode" class="qr-code-img" :src="qrcodeUrl" alt="" />
          <div class="hint">长按二维码保存图片</div>
        </div>

      </div>
    </van-overlay>
    <!--    分享商品-->
    <div class="hidden" style="display: none;">
      <!--    width: 69.33333vw; height: 118.66667vw;-->
      <vue-canvas-poster v-if="qrcodeUrl" :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    </div>
    <!--    分享商品end-->
    <div>
      <tabBar></tabBar>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { VueCanvasPoster } from 'vue-canvas-poster'
import {getWechat} from "@/api/zhibo";
const jweixin = require('jweixin-module');
import tabBar from "@/components/tabBar";
export default {
  name: "activityTheme",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      searchValue: '',
      active: 0,
      items: [{id:1,text:'中山手信'}],
      currItem: '',
      curr: 0,
      wh:'500px',
      giftGoods:[],
      currImg:'',
      page:1,
      finishedTxt: '',
      currId:'',
      loading: false, // 加载动画 是否处于加载状态
      finished: false, // 是否已加载完成
      bannerList: [],
      qrcodeUrl: '', // 二维码
      shareItem: '',
      posterUrl:'', // 海报
      shareGoodsImg: '',
      shareShow:false,
      painting:{
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px'
      },
      comType: '',
      titleShare: '全球灯云',
      desShare: ' ',
      pic:require('./../../assets/logo.jpg'),
      publicPath: 'https://jpzs-zst.itos.cn/'
    }
  },
  components: {
    VueCanvasPoster,
    tabBar
  },
  destroyed() {
    //移除事件处理程序
    window.removeEventListener("pagehide", this.pageHide);
  },
  activated() {
    console.log('activated',this.$route.meta.isBack)
    if (!this.$route.meta.isBack) { // false// 后续进入：beforeRouteEnter => activated => deactivated,
      //isBack 时添加中router中的元信息，判读是否要缓存
      //清空原有数据
      this.currItem = ''
      this.curr = 0
      this.bannerList = []
      this.currItem = ''
      this.itemclass =''
      this.active =0
      this.comType = ''
      this.giftGoods = []
      this.page = 1
      this.comType = this.$route.params.type
      if (this.$route.query.name){
        window.document.title = this.$route.query.name // res.data.desc
        this.$route.meta.title= this.$route.query.name
      }
      this.getCategory() // 重新加载
      console.log('activated不缓存')
    } else {
      console.log('activated缓存')
    }
    this.$route.meta.isBack = false; // 通过这个控制刷新，否则会一直为true
  },
  beforeRouteLeave(to, from, next) { // 列表页面跳转到 详情页时，设置需要缓存 to: 即将要进入的目标 用一种标准化的方式 //from: 当前导航正要离开的路由 用一种标准化的方式
    // 去除背景色
    console.log('离开界面离开界面')
    if (to.path == '/goodDetails') { // goodClassify
      //当离开的时候不是去首页的时候开启缓存
      from.meta.isBack = true;
      // console.log('open缓存meta',from.meta)
    }else {
      from.meta.isBack = false;
      this.giftGoods = []
      this.currItem = ''
      this.curr = 0
      this.bannerList = []
      this.currItem = ''
      this.itemclass =''
      this.active =0
      this.comType = ''
      this.giftGoods = []
      this.page = 1
      // console.log('close缓存meta',from.meta)
    }
    next()
  },
  mounted(){
    this.page = 1
    window.addEventListener("pagehide", this.pageHide);
    this.$nextTick(()=>{ // 页面渲染完成后的回调
      let heightCss = this.$refs.getheight.offsetHeight;
      // console.log(heightCss)
      window.addEventListener("pagehide", this.pageHide);
      let th=document.getElementById('tabbar').offsetHeight
      let wh = document.documentElement.clientHeight
      this.wh = (wh-heightCss-th) + 'px'
    })
  },
  created() {

    this.comType = this.$route.params.type
      console.log('type',this.$route.params.type)
    // window.document.title = '333222' // res.data.desc
    let http = window.location.protocol+'//'
    let url = window.location.hostname // 获取当前访问（域名）
    this.pic = http+url+'/logo.jpg' //'https://jpzs-zst.itos.cn/logo.jpg'
    // this.getCategory()
    // this.getOnePayData()
    // this.getAd()

  },
  methods: {
    //页面关闭或刷新时触发
    pageHide() {
      this.$store.commit("setWechatSignUrl", '');
    },
    getShareInfo(){
      console.log('初始化微信')
// 获取设备信息并判断是否是ios
      var pageUrl = ''
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) { // ios
        // ios系统就拼接随机字符串
        pageUrl = this.$store.state.wxSignUrl
        // console.log('ios')
      } else {
        // console.log('安卓')
        pageUrl = location.href.split('#')[0]
      }

      const data = {
        liveUrl: pageUrl // encodeURIComponent(location.href.split('#')[0]) //  pageUrl
      }
      // console.log(data)
      getWechat(data).then(res => {
        // console.log(res)
        if(res.code == 200)
        {
          let weChat = res.data
          // console.log('weChat',weChat)
          jweixin.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: weChat.appId, // 必填，公众号的唯一标识
            timestamp:weChat.timestamp , // 必填，生成签名的时间戳
            nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
            signature: weChat.signature,// 必填，签名
            jsApiList: ['checkJsApi','onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'] // 跳转小程序时必填
          });
          jweixin.error((res) => {
            console.log('sdk加载失败--->', res)

          })
          // config 准备好了那么就开始操作了，
          jweixin.ready(() => {
            const that = this
            // console.log('ready',that.desShare)
            // wx-open-subscribe 原生绑定点击事件
            this.$nextTick(() => {
              //是否支持分享
              jweixin.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
                success: function (res) {
                  console.log(res)
                }
              });
              let urlPath = location.href.split('#')[0]
              // alert("准备完毕，加载方法");
              //分享到朋友圈
              jweixin.updateTimelineShareData({
                title: that.titleShare,   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: that.pic,   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              });
              jweixin.onMenuShareTimeline({ // 旧版本
                title: that.titleShare,   // 分享时的标题
                link: urlPath,     // 分享时的链接 // keyi
                imgUrl: that.pic,   // 分享时的图标
                success: function () {
                  console.log("分享成功");
                },
                cancel: function () {
                  console.log("取消分享");
                }
              })
              //分享给朋友
              jweixin.updateAppMessageShareData({
                title: that.titleShare,
                desc:' ',
                link: urlPath, // keyi
                imgUrl: that.pic,
                success: function (n) {
                  console.log("分享成功", n);
                },
                complete: function (n) {
                  console.log(n);
                }
              });

              // 旧版本
              jweixin.onMenuShareAppMessage({
                title: that.titleShare, // 分享标题
                desc: ' ', // 分享描述
                link: urlPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: that.pic, // 分享图标
                success: function (e) {
                  // 用户点击了分享后执行的回调函数
                  console.log('分享给朋友',e);
                }
              });


            })
          })

        } else {
          this.$toast(res.message)
        }
      })
    },
    shareShowHide(){
      this.shareItem = ''
      this.shareGoodsImg = ''
      this.qrcodeUrl = ''
      this.shareShow = false
      console.log(this.qrcodeUrl)
      console.log('shareItem',this.shareItem)
    },
    shareClick(goods){ // 生成二维码
      // console.log(goods)
      let that = this
      that.shareItem = goods
      that.shareGoodsImg = goods.image
      let id = goods.id
      let baseUrl = ''
      let http = window.location.protocol+'//'
      let url = window.location.hostname // 获取当前访问（域名）
      baseUrl = http+url+`/goodDetails?id=${id}`  //'https://jpzs-zst.itos.cn/goodDetails?id=750'
      // console.log(baseUrl)

      let qrcodeUrl = baseUrl
      QRCode.toDataURL(qrcodeUrl, (err, qr) => {
        if (err) {
          this.$toast('生成二维码失败');
        } else {
          that.qrcodeUrl = qr;
          // console.log('qrcode',that.qrcodeUrl)
          this.shareShow = true

          this.drawPoster(qr)
        }
      });
      this.drawPoster()
    },
    drawPoster(qr){
      var that = this

      let total = this.shareItem.price * 0.95
      let price = total.toFixed(2);
      let discount = '折后优惠价：'+price
      this.painting = {
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px',
        views: [
          {
            type: 'rect',
            css: {
              width: '502px',
              height: '876px',
              right: '9px',
              bottom: '6px',
              borderRadius: '10px',
              borderWidth: '8px',
              color: '#ffffff',
              borderColor: '#FDD80D',
            }
          },
          {
            type: 'image',
            url: that.shareGoodsImg,// this.shareGoodsImg, // 'https://www.sunniejs.cn/static/avatar.png'
            css: {
              width: '370px',
              height: '370px',
              top: '50px',
              left: '75px'
            }
          },
          {
            type: 'text',
            text: this.shareItem.name,
            css: [
              {
                top: '450px',
                width: '400px',
                maxLines: 2,
                lineHeight: '50px',
                left: '60px',
                fontSize: '26px'
              }
            ]
          },
          {
            type: 'image',
            url: that.qrcodeUrl, // this.qrcodeUrl, //
            css: {
              width: '170px',
              height: '170px',
              top: '570px',
              left: '175px'
            }
          },
          {
            type: "text",
            text: "长按二维码保存图片",
            css: {
              top: "780px",
              left: "136px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
              color: '#E43A0D'
            }
          },
          // {
          //   type: 'rect',
          //   css: {
          //     width: '503px',
          //     height: '106px',
          //     right: '9px',
          //     bottom: '70px',
          //     color: '#feeb86',
          //
          //   }
          // },
          // {
          //   type: "text",
          //   text: "扫码购买立即享受95折",
          //   css: {
          //     bottom: "135px",
          //     left: "136px",
          //     width: "360px",
          //     maxLines:1,
          //     fontSize: "26px",
          //     color: '#E64D2A'
          //   }
          // },
          // {
          //   type: "text",
          //   text: discount, // 扫码购买立即享受95折 折后优惠价：15.2
          //   css: {
          //     bottom: "90px",
          //     left: "134px",
          //     width: "260px",
          //     maxLines:1,
          //     textAlign: 'center',
          //     fontSize: "26px",
          //     color: '#E64D2A'
          //   }
          // },
        ]
      }
    },
    //成功生成海报
    success(src) {
      this.posterUrl = src;
      // console.log(src)
    },
    fail(err) {
      // alert(err)
      console.log('fail', err)
    },
    clickDes(url){ // 详情页
      // console.log(url)
      var url = url
      if (url != null){
        window.open(url)
      } else {
        console.log('null')
      }
      // console.log(url)

    },
    async getCategory() { // 获取左侧菜单
      const data = {
        type:this.comType
      }
      const res = await this.$Http.getGoodsCategories(data)
      console.log(res)
      if (res.code==200){
        var arr = res.data.category
        var arr = JSON.parse(JSON.stringify(arr).replace(/name/g,'text'))
        this.items = arr
        this.currItem = arr[0]
        this.currId =  arr[0].id
        if (this.items[0].banners != ''){
          this.currImg = this.items[0].banner
          // console.log('33',this.currItem.banners)
          // this.pic= this.currItem.banners[0].image
          this.bannerList = this.items[0].banners
        }
        let resData = res
        if (resData.data.title != null){
          window.document.title = resData.data.title // res.data.desc
          this.$route.meta.title= resData.data.title
          this.titleShare = resData.data.title
        } else {
          // console.log('null')
          window.document.title = '全球灯云'
          this.$route.meta.title = '全球灯云'

        }

       if (res.data.desc != null){
         this.desShare = res.data.desc
       }
        this.$nextTick(() => {

          this.getShareInfo()
          this.getGoodListGift()
        })

      } else {
        this.$toast(res.message)
      }
      // console.log(res)
    },
    async getGoodListGift () { // 手信列表
      var data ={
        type: this.comType,
        category_id:this.currId,
        page: 1
      }
      const res = await this.$Http.getGoodsList(data)
      if (res.code == 200){
        // console.log('res',res.data.data.length + 'total',res.data.total)
        this.giftGoods = res.data.data
        // 加载状态结束
        this.loading = false;
        if (res.data.current_page == res.data.last_page){ // 数据全部加载完
          this.finished = true; // 数据全部加载完
          // console.log('不加载')
          if(res.data.data == 0){
            this.finishedTxt = '暂无数据~'
          } else {
            this.finishedTxt = '没有更多了~'
          }
        }else {
          this.finished = false; // 不可以加载
        }

      } else {
        this.$toast(res.message)
      }
    },
    async onLoadMore(){ // more
      var that = this
      this.page += 1;//页数+1
      var data ={
        type: this.comType,
        category_id:this.currId,
        page: this.page
      }
      const res = await this.$Http.getGoodsList(data)
      if (res.code == 200){
        // console.log('res',res.data.data.length + 'total',res.data.total)
        var arr = that.giftGoods.concat(res.data.data);
        this.giftGoods = arr
        this.loading = false; // 加载状态结束
        // 数据全部加载完成
        if (res.data.current_page == res.data.last_page){ // 数据全部加载完
          // console.log('end')
          this.finished = true;
          this.finishedTxt = '没有更多了~'
        } else {
          // console.log('可以加载')
          this.finished = false;
        }
      } else {
        this.$toast(res.message)
        // this.$router.push('/');
      }
    },
    onClickLeft() {
      window.scroll(0, 0);
      if (window.history.length <= 1) {
        this.$router.push({path:'/'})
        return false
      } else {
        this.$router.go(-1)
      }
    },
    clickNav(index){
      // console.log(index)
      this.curr = index
      this.currItem = this.items[index]
      this.currImg = this.items[index].banner
      this.bannerList = this.items[index].banners
      this.currId = this.items[index].id
      this.giftGoods = []
      this.page = 1
      this.finished = true
      this.getGoodListGift()
    },
    onSearch(){
      this.$router.push({path:'/searchList',query:{type:this.comType}})
    },
    goDes(id){
      this.$router.push({path:'/classifyList',query: {id:id}})
    },
    goDesGood(gid,tid,isPay){ // 详情页
      this.$router.push({path:'/goodDetails',query:{id:gid,type:tid,isPay:isPay}})
    },
  }
}
</script>

<style lang="scss" scoped>
.van-tree-select__nav {
  webkit-box-flex: 0.75;
  -webkit-flex: 0.75;
  flex: 0.75;
}
.search-box{
  padding: 34px 42px 34px 27px;
  background: #FDD80D;
  img{
    width: 22px;height: auto;display: inline-block;
  }
  .search-box-sec{
    width: 590px;
    height: 60px;
    line-height: 60px;color: #8C8C8C;font-size: 24px;
    background: #FFFFFF;
    opacity: 0.63;
    border-radius: 30px;text-align: left;padding-left: 28px;
    img{
      width: 34px;height: auto;display: inline-block;
    }
    .searchInput{
      height: 60px;
      line-height: 60px;width: 500px;margin-left: 10px;border: none;background: none;color: #282828;font-size: 28px;
    }
  }
}
.van-sidebar-item--select::before {
  top: 0;height: 100%;
  background-color: #f7f8fa;width: 0px;
}
.van-tree-select{
  color: #282828;font-size: 30px;
}
.van-sidebar-item--select, .van-sidebar-item--select:active {
  font-weight: bold;border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.classify-box{
  .banner-list-box{

  }
  padding-top: 20px;
  .my-swipe{
    margin: 0 20px;
    .van-swipe-item{
      width: 100%;height: 177px;
      .cover-img{
        width: 100%;
        height: 177px;display: block;
        border-radius: 12px;margin: 0 auto;
      }
    }
  }

}
.shop-box{
  font-size: 26px;
  .f-title-box{
    padding: 20px 24px;
    .f-title{
      text-align: left;font-size: 30px;color: #282828;
    }
    .f-title-right{
      font-weight: bold;
      color: #282828;font-size: 22px;
      span{
        color: #F23926;
      }
      img{
        margin-right: 10px;height: auto;display: block;width: 22px;
      }
    }
  }

  .shop-list{
    //-ms-flex-wrap: wrap;
    //flex-wrap: wrap;
    //display: -webkit-box;
    //display: -ms-flexbox;
    //display: flex;
    padding: 0 15px;
    .shop-item{
      text-align: center;padding-bottom: 38px;border-bottom: 1px solid #E8E8E7;margin-bottom: 10px;padding-top: 26px;
      img{
        width: 120px;
        height: 120px;
        border-radius: 10px;margin-right: 15px;
      }
      .content-item{
        width: 370px;
        .title{
          font-size: 24px;text-align: left;color: #000000;line-height: 40px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;margin-bottom: 10px;
          span{
            padding: 2px 5px;background: #F23926;
            border-radius: 5px;font-size: 18px;font-weight: bold;
            color: #FFFFFF;
          }
        }
        .item-bottom{
          .price{
            font-size: 26px;font-weight: bold;
            color: #F23926;
          }
          .rt-box{
            img{
              width: 29px;height: auto;display: inline-block;margin-right:25px;
            }
            .btn{
              background: #FDD80D;
              border-radius: 25px;font-size: 22px;padding: 8px 18px;
              font-weight: bold;
              color: #F23926;
            }
          }
        }
      }

    }
  }
}

.wrapper{
  .icon-box{
    width: 630px;text-align: right;margin: 80px auto 30px;
  }
  .imageWrapper{
    background: #fff;width: 520px;margin: 0 auto;padding: 10px;text-align: center;
    border: 6px solid #FDD80D;
    border-radius: 20px;
  }
  img{
    width: 520px;display: block;height: auto;margin: 0 auto;
  }
  .goodsImg{
    width: 370px;
    height: 370px;
    border-radius: 10px;margin-top: 30px;
  }
  .title{
    width: 370px;margin:20px auto;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .qr-code-img{
    width: 175px;height: 175px;
  }
  .hint{
    padding-bottom: 20px;
  }
}
</style>

